// extracted by mini-css-extract-plugin
module.exports = {"imgs":"Photos_imgs__OCxw_","img":"Photos_img__RK_Ih","around":"Photos_around__oSQEm"};